
import { IReferenceNotificationListDTO } from "../../../services/setpoint-administration-service/Models";
import { RecipientTypeEnum } from "../../../common/enums/RecipientTypeEnum";
import { IFormUserRecipient } from "../../form-recipient-list/FormRecipientListUtils";

export const radioButtons=[{
    label: 'All',
    ariaLabel: "all recipient types",
    value: RecipientTypeEnum.Invalid
},{
    label: RecipientTypeEnum[RecipientTypeEnum.Email],
    ariaLabel: "email",
    value: RecipientTypeEnum.Email
},{
    label: RecipientTypeEnum[RecipientTypeEnum.Text],
    ariaLabel: "text",
    value: RecipientTypeEnum.Text
},{
    label: RecipientTypeEnum[RecipientTypeEnum.Voice],
    ariaLabel: "voice",
    value: RecipientTypeEnum.Voice
}];

const AlarmSetpointNotificationUtils = {
    
    filterRecipients: (data: IFormUserRecipient[], 
        filter: string,
        recipientType: RecipientTypeEnum,
        organizationID: number | undefined
    ) : IFormUserRecipient[] => {

        return data.filter(o => (filter.trim() === '' ||
                                o.userName.toLowerCase().indexOf(filter.trim().toLowerCase()) !== -1 || 
                                o.recipients.find(v => v.to.toLowerCase().indexOf(filter.trim().toLowerCase()) !== -1)) && 
                                (recipientType === RecipientTypeEnum.Invalid || o.recipients.find(v => v.recipientType === recipientType)) &&
                                (organizationID === undefined || o.recipients.find(v => v.organizationID === organizationID)));
    },

    filterNotificationLists: (data: IReferenceNotificationListDTO[], 
        filter: string,
        organizationID: number | undefined
    ) : IReferenceNotificationListDTO[] => {

    return data.filter(o => filter.trim() === '' ||
                            o.name.toLowerCase().indexOf(filter.trim().toLowerCase()) !== -1)
                    .filter(o => o.organizationID === organizationID || organizationID === undefined);
    },
}

export default AlarmSetpointNotificationUtils;